module.exports = __webpack_public_path__ + "img/placeholder3.a2d26945.jpg";